import {
  Target,
  ComponentType,
  Context,
  Size,
} from 'data-types-config';
import type { DestinationItemArchetypeProps } from './DestinationItemArchetype.types';

export const placeholderDestinationItemArchetype: DestinationItemArchetypeProps = {
  ariaLabel: 'Learn More',
  text: 'Learn More About Us',
  link: '/about',
  target: Target.Self,
  componentType: ComponentType.Internal,
  context: Context.Primary,
  size: Size.Medium,
};

export const placeholderDestinationItemArchetypeList: DestinationItemArchetypeProps[] = [
  {
    text: 'External Link',
    link: 'https://example.com',
    target: Target.Blank,
    componentType: ComponentType.External,
  },
  {
    text: 'Send Email',
    link: 'mailto:info@example.com',
    email: 'info@example.com',
    componentType: ComponentType.Email,
  },
];
